import React, { useState } from "react";
import { motion } from "framer-motion";
import col1 from "../../../../assets/images/colleges/1.jpg";
import col2 from "../../../../assets/images/colleges/2.jpg";
import col3 from "../../../../assets/images/colleges/3.jpg";
import col4 from "../../../../assets/images/colleges/4.png";
import "../../../../assets/scss/pages/Career.scss";
const institutions = [
  {
    name: "O P Jindal University, Raigarh",
    description: "Partnered for educational and professional growth.",
    imageUrl: col4,
  },
  {
    name: "ITM University, Raipur",
    description: "Partnered for educational and professional growth.",
    imageUrl: col1,
  },
  {
    name: "Bhilai Institute of Technology, Durg",
    description: "Partnered for educational and professional growth.",
    imageUrl: col2,
  },
  {
    name: "ICFAI, Hyderabad",
    description: "Partnered for educational and professional growth.",
    imageUrl: col3,
  },
];

const InstitutionCard = ({ name, description, imageUrl }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      className="institution-card"
      whileHover={{ y: -10 }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <motion.div className="image-container">
        <img src={imageUrl} alt={name} />
        <motion.div
          className="overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: isHovered ? 1 : 0 }}
        >
          {/* Overlay content can be added here if needed */}
        </motion.div>
      </motion.div>
      <motion.div
        className="content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <h3>{name}</h3>
        <p>{description}</p>
      </motion.div>
    </motion.div>
  );
};

const   PartnerInstitution = () => {
  return (
    <section className="institutions" style={{ margin: "4rem 4rem" }}>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        Partner Institutions
      </motion.h2>
      <div className="institutions-grid">
        {institutions.map((institution, index) => (
          <InstitutionCard key={index} {...institution} />
        ))}
      </div>
    </section>
  );
};

export default PartnerInstitution;
